var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edge SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M115.547 95.291C113.83 96.1834 112.06 96.9685 110.247 97.642C104.505 99.7802 98.4242 100.865 92.2973 100.843C68.6481 100.843 48.0487 84.5864 48.0487 63.6774C48.0794 60.8776 48.8553 58.1365 50.2965 55.7363C51.7377 53.3361 53.7922 51.3635 56.2485 50.0215C34.8491 50.9219 29.3493 73.2315 29.3493 86.2871C29.3493 123.303 63.3982 127.005 70.748 127.005C74.6979 127.005 80.6477 125.854 84.2476 124.704L84.8976 124.504C98.6741 119.74 110.419 110.425 118.197 98.0922C118.423 97.7175 118.52 97.2789 118.473 96.8438C118.426 96.4086 118.238 96.0008 117.937 95.683C117.636 95.3651 117.239 95.1546 116.808 95.0838C116.376 95.013 115.933 95.0858 115.547 95.291Z",
    fill: "url(#paint0_linear_1935_20843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.35,
    d: "M115.547 95.291C113.83 96.1834 112.06 96.9685 110.247 97.642C104.505 99.7802 98.4242 100.865 92.2973 100.843C68.6481 100.843 48.0487 84.5864 48.0487 63.6774C48.0794 60.8776 48.8553 58.1365 50.2965 55.7363C51.7377 53.3361 53.7922 51.3635 56.2485 50.0215C34.8491 50.9219 29.3493 73.2315 29.3493 86.2871C29.3493 123.303 63.3982 127.005 70.748 127.005C74.6979 127.005 80.6477 125.854 84.2476 124.704L84.8976 124.504C98.6741 119.74 110.419 110.425 118.197 98.0922C118.423 97.7175 118.52 97.2789 118.473 96.8438C118.426 96.4086 118.238 96.0008 117.937 95.683C117.636 95.3651 117.239 95.1546 116.808 95.0838C116.376 95.013 115.933 95.0858 115.547 95.291Z",
    fill: "url(#paint1_radial_1935_20843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M52.8485 120.702C48.398 117.937 44.5403 114.315 41.4988 110.047C38.0256 105.291 35.6348 99.8325 34.4943 94.0538C33.3537 88.2752 33.491 82.3169 34.8965 76.5969C36.302 70.877 38.9417 65.5341 42.6302 60.9432C46.3188 56.3523 50.9669 52.6245 56.2483 50.0216C57.8483 49.2713 60.4982 47.9707 64.0481 48.0208C66.5461 48.0401 69.0057 48.6371 71.2348 49.7652C73.4639 50.8933 75.402 52.5218 76.8977 54.5236C78.9094 57.2301 80.0122 60.5049 80.0476 63.8776C80.0476 63.7775 92.2972 24.0604 40.0489 24.0604C18.0995 24.0604 0.0500948 44.8694 0.0500948 63.1773C-0.0372098 72.8482 2.02942 82.4172 6.09991 91.1894C12.7661 105.391 24.412 116.649 38.8271 122.827C53.2421 129.005 69.4227 129.673 84.2975 124.704C79.0862 126.35 73.5797 126.845 68.1585 126.155C62.7373 125.464 57.5307 123.603 52.8985 120.702H52.8485Z",
    fill: "url(#paint2_linear_1935_20843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.41,
    d: "M52.8485 120.702C48.398 117.937 44.5403 114.315 41.4988 110.047C38.0256 105.291 35.6348 99.8325 34.4943 94.0538C33.3537 88.2752 33.491 82.3169 34.8965 76.5969C36.302 70.877 38.9417 65.5341 42.6302 60.9432C46.3188 56.3523 50.9669 52.6245 56.2483 50.0216C57.8483 49.2713 60.4982 47.9707 64.0481 48.0208C66.5461 48.0401 69.0057 48.6371 71.2348 49.7652C73.4639 50.8933 75.402 52.5218 76.8977 54.5236C78.9094 57.2301 80.0122 60.5049 80.0476 63.8776C80.0476 63.7775 92.2972 24.0604 40.0489 24.0604C18.0995 24.0604 0.0500948 44.8694 0.0500948 63.1773C-0.0372098 72.8482 2.02942 82.4172 6.09991 91.1894C12.7661 105.391 24.412 116.649 38.8271 122.827C53.2421 129.005 69.4227 129.673 84.2975 124.704C79.0862 126.35 73.5797 126.845 68.1585 126.155C62.7373 125.464 57.5307 123.603 52.8985 120.702H52.8485Z",
    fill: "url(#paint3_radial_1935_20843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M76.1977 74.4321C75.7477 74.9323 74.4977 75.6826 74.4977 77.2333C74.4977 78.5338 75.3477 79.8344 76.8977 80.8849C84.0474 85.887 97.597 85.1867 97.647 85.1867C102.977 85.1832 108.209 83.7495 112.797 81.0349C117.415 78.3321 121.248 74.4683 123.914 69.8267C126.58 65.1851 127.987 59.9269 127.996 54.5735C128.146 43.3687 123.996 35.9155 122.346 32.6141C111.697 11.9051 88.8473 3.13456e-07 63.9981 3.13456e-07C47.1795 -0.0016635 31.0363 6.62035 19.0599 18.4338C7.08347 30.2473 0.236572 46.3026 6.10352e-05 63.1272C0.250053 44.8693 18.3995 30.113 39.9988 30.113C41.7488 30.113 51.7485 30.263 60.9982 35.1151C67.4965 38.3458 72.8779 43.4509 76.4477 49.7715C79.4976 55.0737 80.0476 61.8266 80.0476 64.5278C80.0476 67.229 78.6976 71.1807 76.1477 74.4821L76.1977 74.4321Z",
    fill: "url(#paint4_radial_1935_20843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M76.1977 74.4321C75.7477 74.9323 74.4977 75.6826 74.4977 77.2333C74.4977 78.5338 75.3477 79.8344 76.8977 80.8849C84.0474 85.887 97.597 85.1867 97.647 85.1867C102.977 85.1832 108.209 83.7495 112.797 81.0349C117.415 78.3321 121.248 74.4683 123.914 69.8267C126.58 65.1851 127.987 59.9269 127.996 54.5735C128.146 43.3687 123.996 35.9155 122.346 32.6141C111.697 11.9051 88.8473 3.13456e-07 63.9981 3.13456e-07C47.1795 -0.0016635 31.0363 6.62035 19.0599 18.4338C7.08347 30.2473 0.236572 46.3026 6.10352e-05 63.1272C0.250053 44.8693 18.3995 30.113 39.9988 30.113C41.7488 30.113 51.7485 30.263 60.9982 35.1151C67.4965 38.3458 72.8779 43.4509 76.4477 49.7715C79.4976 55.0737 80.0476 61.8266 80.0476 64.5278C80.0476 67.229 78.6976 71.1807 76.1477 74.4821L76.1977 74.4321Z",
    fill: "url(#paint5_radial_1935_20843)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1935_20843",
    x1: 29.3493,
    y1: 88.5381,
    x2: 118.547,
    y2: 88.5381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1935_20843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.5978 89.2109) scale(47.6985 45.3345)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1935_20843",
    x1: 76.3477,
    y1: 49.8215,
    x2: 20.6715,
    y2: 110.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1935_20843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2765 99.5114) rotate(-81.3883) scale(71.7232 57.9196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1935_20843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9447 23.6682) rotate(92.2896) scale(101.325 215.701)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1935_20843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.026 38.6667) rotate(73.7469) scale(48.6692 39.5624)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.17c2ece39931fea436f43aab83419001.svg";
export { ForwardRef as ReactComponent };